import { ATTR_SRC, CLASS_HIDDEN } from './strings';

export interface BindImageOptions {
  placeholderEl?: HTMLElement | null;
  removeBtnEl?: HTMLElement | null;
  fallbackEl?: HTMLElement | null;
}

/**
 * Binds an image URL to an HTMLImageElement with automatic onload/onerror handling,
 * placeholder management, and fallback display.
 */
export function bindImage(
  imgEl: HTMLImageElement | null,
  src: string | null | undefined,
  options?: BindImageOptions
): void {
  if (!imgEl) return;

  const setLoaded = (ok: boolean) => {
    imgEl.classList.toggle(CLASS_HIDDEN, !ok);
    options?.placeholderEl?.classList.toggle(CLASS_HIDDEN, ok);
    options?.removeBtnEl?.classList.toggle(CLASS_HIDDEN, !ok);
    options?.fallbackEl?.classList.toggle(CLASS_HIDDEN, ok);
  };

  if (!src) {
    imgEl.removeAttribute(ATTR_SRC);
    setLoaded(false);
    return;
  }

  imgEl.onload = () => setLoaded(true);
  imgEl.onerror = () => setLoaded(false);
  imgEl.src = src;
}
